
export default {
  props: {
    res_ids: {
      type: Array,
      required: true
    },
    prefix: {
      type: String,
      required: true
    },
    resource_type: {
      type: String,
      required: true
    },
    creative_id: {
      type: Number,
      required: true
    },
    res_type: {
      type: Number,
      required: true
    }
  },

  methods: {
    openResourcesDialog: function openResourcesDialog() {
      this.$store.commit('creative/template/openCloudResourcesDialog');
      this.$store.commit('creative/template/updateCloudResources', {
        res_ids: this.res_ids,
        prefix: this.prefix,
        resource_type: this.resource_type,
        creative_id: this.creative_id,
        res_type: this.res_type
      });
    }
  }
};